const NEARBY_DEVICE_IDENTITY_KEY = "netpad.nearbyDeviceIdentity";
const DEVICE_NAME_PREFIXES = ["Blue", "Green", "Silver", "Coral", "Amber"];
const DEVICE_NAME_RANDOM_LIMIT = 9000;
const DEVICE_NAME_RANDOM_OFFSET = 1000;

const createFallbackId = () =>
  `device-${Date.now().toString(36)}-${Math.random().toString(36).slice(2)}`;

export const createNearbyId = () => {
  if (window.crypto?.randomUUID) return window.crypto.randomUUID();

  return createFallbackId();
};

const createDeviceName = () => {
  const index = Math.floor(Math.random() * DEVICE_NAME_PREFIXES.length);
  const suffix = Math.floor(Math.random() * DEVICE_NAME_RANDOM_LIMIT);
  return `Netpad ${DEVICE_NAME_PREFIXES[index]} ${suffix + DEVICE_NAME_RANDOM_OFFSET}`;
};

const isValidIdentity = (identity) =>
  Boolean(identity?.deviceId) && Boolean(identity?.deviceName);

const readStoredIdentity = (storage) => {
  try {
    return JSON.parse(storage.getItem(NEARBY_DEVICE_IDENTITY_KEY));
  } catch (error) {
    return null;
  }
};

const writeStoredIdentity = ({ storage, identity }) => {
  try {
    storage.setItem(NEARBY_DEVICE_IDENTITY_KEY, JSON.stringify(identity));
  } catch (error) {
    return;
  }
};

export const createNearbyDeviceIdentity = () => ({
  deviceId: createNearbyId(),
  deviceName: createDeviceName(),
});

export const getOrCreateNearbyDeviceIdentity = ({
  storage = window.localStorage,
} = {}) => {
  const storedIdentity = readStoredIdentity(storage);
  if (isValidIdentity(storedIdentity)) return storedIdentity;

  const identity = createNearbyDeviceIdentity();
  writeStoredIdentity({ storage, identity });
  return identity;
};
